import type { Resource } from '../../';
export const account_title: Resource = {"default":"My Account"};
